import {Action, PayloadAction} from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import acapellasSaga from './saga';
import { AcapellasState } from './types';

export const initialState: AcapellasState = {
  acapellas: [],
  songs: [],
  query: [],
  isLoading: false,
  selectedAcapella: undefined,
};

const slice = createSlice({
  name: 'acapellas',
  initialState,
  reducers: {
    fetchAcapellas(state, action: Action<any>) {
      console.log("fetchAcapellasReducer");
      // Saga side effect will make api call
      // @ts-ignore
      let isPolling = action.payload.isPolling
      if (!isPolling) {
        state.isLoading = true;
      }
    },
    updateAcapellas(state, action: PayloadAction<any>) {
      // @ts-ignore
      state.acapellas = action.payload.acapellas;
      state.isLoading = false;
    },
    fetchAcapellasError(state, action: PayloadAction<any>) {
      // Saga side effect will make api call
      state.isLoading = false;
    },
    setSelectedAcapella(state, action: PayloadAction<any>) {
      state.selectedAcapella = action.payload
    },
    searchSongs(state, action: PayloadAction<any>) {
      console.log("searchSongsReducer");
      // Saga side effect will make api call
      if (action.payload?.query) {
        state.query = action.payload.query
        // @ts-ignore
        state.isLoadingSongs = true;
      }
      // if not explicitly passed query, just refresh
      // TODO better polling?
    },
    updateSongs(state, action: PayloadAction<any>) {
      // @ts-ignore
      state.songs = action.payload.songs;
      // @ts-ignore
      state.isLoadingSongs = false;
    },
    searchSongsError(state, action: PayloadAction<any>) {
      // Saga side effect will make api call
      // @ts-ignore
      state.isLoadingSongs = false;
    },
    setSongParamLocal(state, action: PayloadAction<any>) {
      const song_uuid = action.payload.uuid;
      const param_key = action.payload.key;
      const new_value = action.payload.value;
      const newSongs = state.songs.map((s) => {
        if (s.uuid === song_uuid) {
          return Object.assign({}, s, { [param_key]: new_value } )
        }
        return s
      })
      // @ts-ignore
      state.songs = newSongs
    }
  },
});

export const { actions: acapellasActions } = slice;

export const useAcapellasSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: acapellasSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useAcapellasSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
